import type { ApiError } from '../../../../common/api/graphql/apolloClient';
import type { GetProjectsQuery } from '../../../../common/api/graphql/getProjectsGql';
import { getProjects } from '../../../../common/api/graphql/getProjectsGql';
import {
  getProjectsFailure,
  getProjectsStart,
  getProjectsSuccess
} from '../actions';
import type { AppThunkAction } from '../thunkType';
import handleApiErrorIfNeeded from './handleApiErrorIfNeeded';

const getProjectsSuccessThunk =
  (projects: GetProjectsQuery['projects']): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(getProjectsSuccess(projects));
    return Promise.resolve();
  };

export const getProjectsFailureThunk =
  (error: ApiError): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(getProjectsFailure());
    return dispatch(handleApiErrorIfNeeded(error));
  };

export const getProjectsThunk =
  (): AppThunkAction<Promise<void>> => dispatch => {
    dispatch(getProjectsStart());
    return getProjects()
      .then(response =>
        dispatch(getProjectsSuccessThunk(response.data!.projects))
      )
      .catch(error => dispatch(getProjectsFailureThunk(error)));
  };
